import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useAuth } from 'Contexts/AuthProvider'
import useFleetDepartments from 'Hooks/useFleetDepartments'
import FleetDashboard from './FleetDashboard/FleetDashboard'

const FleetViewPage = () => {
  const { currentUser, token } = useAuth()
  const currentCompany = useSelector((state) => state.dashboard.currentCompany)
  const allowUiFleetView = useMemo(
    () => currentUser?.allowUiFleetView?.() || currentUser?.showFleetView?.(),
    [currentUser]
  )
  const companyId = useMemo(() => {
    if (currentUser?.isSuperuser?.()) return currentCompany?.id
    return currentUser?.companyId || currentCompany?.id
  }, [currentUser, currentCompany])

  const {
    data: departments = [],
    isLoading: isLoadingDepartments,
  } = useFleetDepartments(allowUiFleetView ? companyId : null)

  if (!allowUiFleetView) {
    return (
      <main style={{ padding: '35px 15px' }}>
        <div className="pageBlock">
          <div className="pageCard">
            <div
              style={{
                textAlign: 'center',
                padding: '40px 20px',
                fontSize: '16px',
                color: '#4444448f',
              }}
            >
              <div>{'You do not have permission to view this page'}</div>
            </div>
          </div>
        </div>
      </main>
    )
  }

  return (
    <div className="fleetViewPage">
      <div className="fleetViewPageContent">
        <FleetDashboard
          departments={departments}
          isLoadingDepartments={isLoadingDepartments}
          token={token}
          companyId={companyId}
        />
      </div>
    </div>
  )
}

export default FleetViewPage
